import React, { useState, useEffect, useRef } from 'react';
import '../Admin.css'; // Import CSS for styling
import { useNavigate, Link } from 'react-router-dom';
import { login, getAllDataWithFlag, getmenubyId, adminforgotpassword, adminResetpassword } from '../../../services/CommonService';
import { useAuth } from '../../../Utils/AuthProvider';
import Swal from "sweetalert2";



function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usermenudata, setusermenudata] = useState('');
  const [menudata, setmenudatabyId] = useState('');
  const [email, setEmail] = useState('');
  const [timeLeft, setTimeLeft] = useState(120);
  const intervalRef = useRef(null);
  const [showEmailVerification, setShowEmailVerification] = useState(true);
  const [menuData, setfiltermenu] = useState('');
  const [otp, setOtp] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setAuthToken } = useAuth();
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaError, setCaptchaError] = useState('');



  useEffect(() => {
    if (timeLeft > 0 && intervalRef.current === null) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [timeLeft]);


  const formatTime = (seconds) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, '0');
    const sec = String(seconds % 60).padStart(2, '0');
    return `${min}:${sec}`;
  };

  function generateCaptcha() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaInput('');
    setCaptchaError('');
  };


  const validatePassword = (password) => {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,10}$/;
    return regex.test(password);
  };

  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setPasswordError('Passwords do not match');
    } else {
      setPasswordError('');
    }
  }, [password, confirmPassword]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleotpChange = (event) => {
    setOtp(event.target.value);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    if (captchaInput !== captcha) {
      setCaptchaError('Captcha does not match');
      return;
    }
    setCaptchaError('');
    try {
      const response = await login({ // Replace with your actual API endpoint
        email: username,
        password: password,
      });
      const data = response.data; // axios automatically parses JSON
      if (response.status === 200) { // Check for successful status code
        setAuthToken(data.token);
        const mstlookup = await getAllDataWithFlag(3);
        const master = await getAllDataWithFlag(11);
        const alluserwithmenu = await getAllDataWithFlag(13);
        const getUserMenuById = await getmenubyId(data?.user?.role);
        const usermenudata = alluserwithmenu?.data?.menu;
        const menudata = getUserMenuById?.data;
        setusermenudata(usermenudata);
        setmenudatabyId(menudata);
        localStorage.setItem('roledata', JSON.stringify(alluserwithmenu?.data?.role))
        if (usermenudata && menudata) {
          const filteredMenu = usermenudata.filter(m =>
            menudata.some(d => d.menu_id == m.id && d.can_display == true)
          );
          setfiltermenu(filteredMenu)
          localStorage.setItem('menuData', JSON.stringify(filteredMenu))
        }
        localStorage.setItem('lookup', JSON.stringify(mstlookup?.data?.mstlookup));
        localStorage.setItem('StateMaster', JSON.stringify(master?.data));
        localStorage.setItem('admin', JSON.stringify(data))
        navigate('/admin/dashboard');
      } else {
        setError(data.message || 'Invalid username or password.');
      }
    } catch (error) {
      setError('Failed to connect to the server.');
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message); // Display server-specific error
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await adminforgotpassword({ email: email });
      if (response.status === 200) {
        setTimeLeft(120); // Restart countdown
        Swal.fire("OTP Resent", "Please check your email", "success");
      } else {
        Swal.fire("Failed", "Unable to resend OTP", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      response = await adminforgotpassword({ email: email });
      if (response.status == 200) {
        Swal.fire({
          title: "OTP sent on your registered email. Please check",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok"
        })
        setTimeLeft(120);
        setShowEmailVerification(false);
      } else {
        setError('Failed to send OTP. Try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  const handleForgetPassword = async (event) => {
    event.preventDefault();
    setError('');
    try {
      const forgetData = {
        email: email,
        otp: otp,
        password: password,
        password_confirmation: confirmPassword
      }
      let response;
      response = await adminResetpassword(forgetData);
      if (response.status == 200) {
        Swal.fire({
          title: "Success",
          text: "Password Reset Succesful",
          icon: "success",
          confirmButtonText: "OK",
        });
        setShowForgetPassword(false);
        setShowEmailVerification(true);
      }
    } catch (error) {
      setError('Failed to connect to the server.');
      console.error('Login error:', error);
      Swal.fire({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
        confirmButtonText: "OK",
      });
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message); // Display server-specific error
      }
    }
  };



  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f7f7f7',
      }}
    >
      <div className="admin-login-container" style={{
        border: '2px solid #ccc',
        padding: '30px',
        borderRadius: '12px',
        backgroundColor: '#fff',
        width: '100%',
        maxWidth: '450px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img
            src="/logo1.png"
            alt="ACWADAM Logo"
            className="logos"
            style={{ maxWidth: '150px', height: 'auto' }}
          />
        </div>
        <h2>
          {showForgetPassword
            ? showEmailVerification
              ? 'Verify Email'
              : 'Reset Password'
            : 'Admin Login'}
        </h2>
        {error && <p className="error-message">{error}</p>}
        {showForgetPassword ? (
          showEmailVerification ? (
            <form onSubmit={handleEmailSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address:</label>
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="login-button w-100">Send OTP</button>
              <div className="mt-3 text-center">
                <span
                  style={{ fontSize: 'small', cursor: 'pointer' }}
                  onClick={() => {
                    setShowForgetPassword(false);
                    setShowEmailVerification(true);
                  }}
                >
                  ← Back to Login
                </span>
              </div>
            </form>
          ) : (
            <form onSubmit={handleForgetPassword}>
              <div className="form-group">
                <label htmlFor="otp">OTP:</label>
                <input
                  type="text"
                  id="otp"
                  placeholder="OTP"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      setOtp(value);
                    }
                  }}
                  required
                />
                {otp && (otp.length < 1 || otp.length > 10) && (
                  <div style={{ color: 'red' }}>
                    OTP must be between 1 to 10 digits.
                  </div>
                )}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                  <span style={{ color: timeLeft === 0 ? 'red' : 'black', marginRight: '10px' }}>
                    OTP expires in: <strong>{formatTime(timeLeft)}</strong>
                  </span>

                  {timeLeft === 0 && (
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        padding: '5px 10px',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>

              </div>
              <div className="form-group">
                <label htmlFor="password">New Password:</label>
                <input
                  type="password"
                  value={password}
                  placeholder="New Password"
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={() => {
                    if (!validatePassword(password)) {
                      setPasswordError("Password must be between 4 to 10 chars long with letter, number & special character.");
                    } else {
                      setPasswordError("");
                    }
                  }}
                  required
                />
                {passwordError && (
                  <div style={{ color: 'red', marginTop: '5px' }}>{passwordError}</div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="Cpassword">Confirm Password:</label>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="login-button w-100" >
                Reset Password
              </button>
              <div className="mt-3 text-center">
                <span
                  style={{ fontSize: 'small', cursor: 'pointer' }}
                  onClick={() => {
                    setShowForgetPassword(false);
                    setShowEmailVerification(true);
                  }}
                >
                  ← Back to Login
                </span>
              </div>
            </form>
          )
        ) : (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group" style={{ position: 'relative' }}>
              <label htmlFor="password">Password:</label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ paddingRight: '40px' }}
              />
              <i
                className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '38px',
                  cursor: 'pointer',
                  color: '#888',
                }}
              ></i>
            </div>
            <div className="form-group">
              <label>Captcha:</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
                <input
                  type="text"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  required
                  placeholder="Enter captcha"
                  style={{ flex: '1' }}
                />
                <div
                  style={{
                    backgroundColor: '#f0f0f0',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                    padding: '5px 10px',
                    borderRadius: '4px',
                    letterSpacing: '2px',
                    userSelect: 'none',
                  }}
                >
                  {captcha}
                </div>
                <i
                  className="bi bi-arrow-clockwise"
                  onClick={refreshCaptcha}
                  style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                  title="Refresh Captcha"
                ></i>
              </div>
              {captchaError && <div style={{ color: 'red', fontSize: '0.8rem' }}>{captchaError}</div>}
            </div>
            <div style={{ textAlign: 'right', marginBottom: '10px' }}>
              <span
                style={{ fontSize: '0.9rem', color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  setShowForgetPassword(true);
                  setShowEmailVerification(true); // start email step
                }}
              >
                Forgot Password?
              </span>
            </div>
            <button type="submit" className="login-button w-100">Login</button>
          </form>
        )}
      </div>
    </div>
  );


}

export default Login;